import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientDetailContactTypeModel from "../../models/client-detail-contact-type";

export default class ClientDetailContactTypeRepository extends BaseRepository {
  static modelClass = ClientDetailContactTypeModel;
  modelName = "client-detail-contact-type";

  async query() {
    return await super.query({
      content_type: "contactrelation",
      field_name: "relation_type",
      limit: 100,
    });
  }
}
